<template>
  <div>
  <div class="createdTitle-body">
       <img src="../../assets/image/screenImg/anquan.png" alt="" class="leftTopIcon">
   <p class="createdTitle">安全管理</p>
  <screenNavigation class="screenNavigation" :name='createdName' ref="leftclick" v-clickoutside="handleClickOutside"></screenNavigation>
   </div>
 
    <!-- ==========左侧区域========== -->
    <div class="leftBody">
      <div class="leftBody-title" style="padding-right: 0.8333vw">
        <img class="jiantou" src="../../assets/image/screenImg/jt.png" alt="" />
        <p class="title-txt">设备列表</p>
      </div>
      <!-- 头部盒子下方的线条 -->
      <div class="border-Max">
        <div class="border-left"></div>
        <div class="border-center"></div>
        <div class="border-right"></div>
      </div>
      <div class="leftBody-body" style="overflow: hidden">
        <div class="left-list-body" :class="{ anim: animate }">
          <div
            class="leftBody-body-list"
            v-for="(item, index) in deviceList"
            :key="index"
            @click="endFun(item)"
          >
           <div class="jihuojiantou">
              <img
                src="../../assets/image/screenImg/jiantou.png"
                alt=""
                class="jihuojiantouimg"
                v-show="item.id == id"
              />
            </div>
            <p class="leftList-name">{{ item.name }}</p>
            <p class="leftList-num">序列号: {{ item.deviceId }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- ==========中心区域========== -->
    <div class="centerBody">
      <div class="centerTop">
        <div class="centerTop-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">龙门吊设备信息</p>
        </div>
        <div class="border-center-Max">
          <div class="border-center-left"></div>
          <div class="border-center-center"></div>
          <div class="border-center-right"></div>
        </div>
        <div class="centerTop-body">
          <p class="centerTop-body-left-a">
            当前工作时间：<span>{{ info.workingtime || 0 }}min</span>
          </p>
          <p class="centerTop-body-left-b">
            累计工作时间：<span>{{ info.alltime || 0 }}h</span>
          </p>
          <p class="centerTop-body-right-a">
            大车刚腿侧位置：<span>{{ info.gan1Pos || 0 }}m</span>
          </p>
          <p class="centerTop-body-right-b">
            大车柔腿侧位置：<span>{{ info.gan2Pos || 0 }}m</span>
          </p>
          <p class="centerTop-body-right-c">
            大车柔腿偏斜值：<span>{{ info.ganDef || 0 }}m</span>
          </p>
          <img
            src="../../assets/image/screenImg/longmndiao.png"
            alt=""
            class="center-icon"
          />
        </div>
      </div>
      <div class="centerBottom">
        <div class="centerTop-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">预警记录</p>
        </div>
        <div class="border-center-Max">
          <div class="border-center-left"></div>
          <div class="border-center-center"></div>
          <div class="border-center-right"></div>
        </div>
        <div class="rightBody-body" style="overflow: hidden">
          <div class="left-list-body ringhtArry" :class="{ anim2: animate2 }">
            <div
              class="rightBody-body-list"
              v-for="item in earlyWarningList"
              :key="item.id"
            >
              <!-- <p class="leftList-name">{{item.name}}</p>
<p class="leftList-num">序列号: {{item.imei}}</p> -->
              <p class="yj-name">{{ item.alarmName }}</p>
              <p class="yj-num">{{ item.alarmValue }}</p>
              <p class="yj-tim">{{ item.createDate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ==========右侧区域========== -->
    <div class="rightBody">
      <div class="right-top">
        <div class="leftBody-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">前天车数据监测表</p>
        </div>
        <div class="border-Max">
          <div class="border-left"></div>
          <div class="border-center"></div>
          <div class="border-right"></div>
        </div>
        <div
          class="right-bottom-body"
          style="padding-left: 0.8333vw; padding-top: 1.25vw"
        >
          <div class="right-list">
            <p class="right-list-name">前天车主起升高度</p>
            <p class="right-list-num">
              {{ Number(info.main1Pos ? info.main1Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">前天车副起升高度</p>
            <p class="right-list-num">
              {{ Number(info.aux1Pos ? info.aux1Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">前天车主起升重量</p>
            <p class="right-list-num">
              {{ Number(info.main1W ? info.main1W : 0).toFixed(1) }}T
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">前天车副起升重量</p>
            <p class="right-list-num">
              {{ Number(info.aux1W ? info.aux1W : 0).toFixed(1) || 0 }}T
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">前天车小车位置</p>
            <p class="right-list-num">
              {{ Number(info.tro1Pos ? info.tro1Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
        </div>
      </div>
      <div class="right-bottom">
        <div class="leftBody-title">
          <img
            class="jiantou"
            src="../../assets/image/screenImg/jt.png"
            alt=""
          />
          <p class="title-txt">后天车数据监测表</p>
        </div>
        <div class="border-Max">
          <div class="border-left"></div>
          <div class="border-center"></div>
          <div class="border-right"></div>
        </div>
        <div
          class="right-bottom-body"
          style="padding-left: 0.8333vw; padding-top: 1.25vw"
        >
          <div class="right-list">
            <p class="right-list-name">后天车主起升高度</p>
            <p class="right-list-num">
              {{ Number(info.main2Pos ? info.main2Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">后天车副起升高度</p>
            <p class="right-list-num">
              {{ Number(info.aux2Pos ? info.aux2Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">后天车主起升重量</p>
            <p class="right-list-num">
              {{ Number(info.main2W ? info.main2W : 0).toFixed(1) }}T
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">后天车副起升重量</p>
            <p class="right-list-num">
              {{ Number(info.aux2W ? info.aux2W : 0).toFixed(1) }}T
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
          <div class="right-list">
            <p class="right-list-name">后天车小车位置</p>
            <p class="right-list-num">
              {{ Number(info.tro2Pos ? info.tro2Pos : 0).toFixed(1) }}m
            </p>
            <p class="right-list-time">{{ info.createDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import myHttp from '../../untils/port'
import util from '../../untils/util'
import screenHttp from '../../untils/screenHttp'
import base from '../../untils/base'
import screenNavigation from './screenNavigation.vue'
export default {
        directives: { Clickoutside },
  data() {
    return {
      createdName:'龙门吊监测',
      timer2: null,
      deviceList: [], //龙门吊设备列表
      id: '', //龙门吊id
      earlyWarningList: [], //预警纪录信息
      projectId: util.session.get('groupId'),
      animate2: false,
      animate: false,
      info: {},
    }
  },

components:{
  screenNavigation
},

  created() {
    this.selectEquipGantryPage()
  },
  beforeDestroy() {
    // 页面销毁前清空滚动动画的定时器
    window.clearInterval(this.timer)
    window.clearInterval(this.timer2)
  },
  methods: {
       handleClickOutside(){
      this.$refs.leftclick.listShow=false
    },
    // 获取龙门吊设备
    async selectEquipGantryPage() {
      const data = await screenHttp.selectEquipGantryPage({
        projectId: this.projectId,
        pageSize: 999,
        pageNum: 1,
        name: '',
      })
      if (data.data.code == 200) {
        console.log('龙门吊设备列表接口信息--->', data)
        this.deviceList = data.data.data.pageInfo.list
        console.log('龙门吊设备列表--->', this.deviceList)
        if (this.deviceList.length > 0) {
          this.id = this.deviceList[0].id
          this.selectEquipGantryAlarmDetailPage()
          this.selectEquipGantryRecord()
          this.timer = setInterval(this.scroll, 2000)
        }
      }
    },
    // 设备列表滚动动画执行判断
    scroll() {
      if (this.deviceList.length > 12) {
        console.log('动画a')
        this.animate = true
        setTimeout(() => {
          this.deviceList.push(this.deviceList[0])
          this.deviceList.shift()
          this.animate = false
        }, 1200)
      } else {
        window.clearInterval(this.timer)
      }
    },
    // 获取龙门吊预警
    async selectEquipGantryAlarmDetailPage() {
      const data = await myHttp.selectEquipGantryAlarmDetailPage({
        gantryId: this.id,
        pageSize: 9999,
        pageNum: 1,
      })
      if (data.data.code == 200) {
        console.log('----->龙门吊预警信息', data)
        console.log(data.data.data.pageInfo.list)
        this.earlyWarningList = data.data.data.pageInfo.list
        console.log('预警信息数组----->', this.earlyWarningList)
        this.timer2 = setInterval(this.scroll2, 2000)
      }
    },
    scroll2() {
      if (this.earlyWarningList.length > 9) {
        this.animate2 = true
        setTimeout(() => {
          this.earlyWarningList.push(this.earlyWarningList[0])
          this.earlyWarningList.shift()
          this.animate2 = false
        }, 1200)
      } else {
        window.clearInterval(this.timer2)
      }
    },
    // 获取龙门吊信息
    async selectEquipGantryRecord() {
      const data = await myHttp.selectEquipGantryRecord({
        gantryId: this.id,
      })
      if (data.data.code == 200) {
        console.log('龙门吊信息------>', data)
        this.info = data.data.data || {}
      }
    },
    // 切换设备处理函数
    endFun(item) {
      window.clearInterval(this.timer2)
      window.clearInterval(this.timer)
      console.log(item)
      this.id = item.id
      this.selectEquipGantryAlarmDetailPage()
      this.selectEquipGantryRecord()
    },
  },
}
</script>

<style scoped>
.maxBody {
}
.leftBody {
  width: 24.7917vw;
  height: 44.7917vw;
  /* background: pink; */
  float: left;
  margin-left: 1.25vw;
  z-index: 99;
}
.centerBody {
  width: 41.6667vw;
  height: 44.7917vw;
  /* background:black; */
  float: left;
  margin-left: 3.125vw;
}
.rightBody {
  width: 24.7917vw;
  height: 44.7917vw;
  /* background: pink; */
  float: left;
  margin-left: 3.125vw;
}
.leftBody-title {
  width: 24.7917vw;
  height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%
  );
  text-align: left;
  line-height: 2.0833vw;
}
.jiantou {
  float: left;
  width: 2.3021vw;
  height: 1.1021vw;
  margin-top: 0.45vw;
}
.title-txt {
  font-family: PingFang SC;
  font-size: 0.9375vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
  float: left;
}
.leftBody-body {
  height: 41.7025vw;
  width: 24.7917vw;
  /* background: pink; */
  padding-top: 0.5208vw;
  overflow: hidden;
}
.leftBody-body-list {
  padding-top: 0.2083vw;

  text-align: left;
  width: 24.7917vw;
  height: 2.9167vw;
  border: 0.0521vw solid;
  border-right: 0;
  border-left: 0;
  /* border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, #61A3F6 52%, rgba(140,180,231,0.00) 100%) 1; */
  margin-bottom: 0.5208vw;
  background: linear-gradient(
    270deg,
    rgba(79, 102, 131, 0) 0%,
    #142a4f 52%,
    rgba(79, 102, 131, 0) 100%
  );
}
.left-list-body {
  width: 100%;
  height: 110%;
  /* background: #0B213C; */
}
.centerTop {
  width: 41.6667vw;
  height: 20.8333vw;

  margin-bottom: 3.125vw;
}
.centerBottom {
  width: 41.6667vw;
  height: 20.8333vw;
}
.centerTop-title {
  width: 41.6667vw;
  height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%
  );
  text-align: left;
  line-height: 2.0833vw;
}
.centerTop-body {
  position: relative;
  width: 41.6667vw;
  height: 18.5417vw;
  background: rgba(0, 35, 102, 0.2);
}
.right-top {
  width: 24.7917vw;
  height: 20.8333vw;
  /* background:black ; */
  margin-bottom: 3.025vw;
}
.right-bottom {
  width: 24.7917vw;
  height: 20.8333vw;
  /* background:black; */
}
.leftList-name {
  font-family: PingFang SC;
  font-size: 0.8333vw;
  font-weight: normal;
  letter-spacing: 0em;
  margin-bottom: 0.2083vw;
  color: #ffffff;
}
.leftList-num {
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
}
.anim {
  margin-top: -3.52vw;
  transition: all 1s;
}
.anim2 {
  margin-top: -2.0833vw;
  transition: all 1s;
}

.rightBody-body {
  width: 100%;
  height: 18.5417vw;
  background: rgba(0, 35, 102, 0.2);
  margin-bottom: 1.0417vw;
}
.rightBody-body-list {
  padding-top: 0.2083vw;
  padding-left: 0.8333vw;
  text-align: left;
  width: 100%;
  height: 2.0833vw;
  border: 0.0521vw solid;
  border-right: 0;
  border-left: 0;
  /* border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, #61A3F6 52%, rgba(140,180,231,0.00) 100%) 1; */

  background: linear-gradient(
    270deg,
    rgba(79, 102, 131, 0) 0%,
    #142a4f 52%,
    rgba(79, 102, 131, 0) 100%
  );
}
.ringhtArry {
}
.yj-title {
  float: left;
  width: 40%;

  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ff0000;
  line-height: 1.733vw;
}
.yj-right {
  float: right;
  width: 40%;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
  line-height: 1.733vw;
}
.gaoguang {
  color: #01fdfc;
}
.right-bottom-body {
  width: 24.7917vw;
  height: 18.5417vw;

  background: rgba(0, 35, 102, 0.2);
}
.border-Max {
  margin-top: 0.1042vw;
}
.border-left {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
  margin-right: 0.2083vw;
}
.border-center {
  width: 23.6458vw;
  height: 0.1042vw;
  background: linear-gradient(90deg, #11273f 0%, #608cca 52%, #040d1f 100%);
  float: left;
  margin-right: 0.2083vw;
}
.border-right {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
}
.border-center-Max {
  margin-top: 0.1042vw;
}
.border-center-left {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
  margin-right: 0.2083vw;
}
.border-center-center {
  width: 40.5208vw;
  height: 0.1042vw;
  background: linear-gradient(90deg, #11273f 0%, #608cca 52%, #040d1f 100%);
  float: left;
  margin-right: 0.2083vw;
}
.border-center-right {
  width: 0.3646vw;
  height: 0.1042vw;
  background: #518fe3;
  float: left;
}
.yj-name {
  width: 9.8958vw;
  margin-right: 9.9896vw;
  font-family: Source Han Sans CN;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ff0000;
  float: left;
}
.yj-num {
  width: 5.5729vw;
  margin-right: 6.8125vw;
  font-family: Source Han Sans CN;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ff0000;
  float: left;
}
.yj-tim {
  float: left;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
}
.right-list {
  padding-left: 0.625vw;
  display: flex;
  border-radius: 4px;
  margin-bottom: 1.4063vw;
  opacity: 1;
  width: 23.125vw;
  height: 2.0833vw;
  background: rgba(216, 216, 216, 0.01);

  box-sizing: border-box;
  border: 1px solid;
  border-image: linear-gradient(
      270deg,
      rgba(12, 96, 165, 0) 0%,
      rgba(12, 96, 165, 0.6) 51%,
      rgba(12, 96, 165, 0) 100%
    )
    1;

  box-shadow: inset 0px 0px 0.5208vw 0px rgba(12, 96, 165, 0.3);
  line-height: 2.0833vw;
}
.right-list-name {
  width: 5.8333vw;
  opacity: 1;

  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  margin-right: 3.6458vw;
  color: #ffffff;
}
.right-list-num {
  width: 1.875vw;
  opacity: 1;

  font-family: Source Han Sans CN;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
  margin-right: 2.9167vw;
}
.right-list-time {
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: rgba(255, 255, 255, 0.6);
}
.centerTop-body-left-a {
  opacity: 1;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  position: absolute;
  top: 1.25vw;
  left: 1.25vw;
  color: #ffffff;
}
.centerTop-body-left-b {
  position: absolute;
  top: 2.9167vw;
  left: 1.25vw;
  opacity: 1;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
}
.centerTop-body-left-a span,
.centerTop-body-left-b span,
.centerTop-body-right-a span,
.centerTop-body-right-b span, 
.centerTop-body-right-c span {
  color: #01fdfc;
}
.centerTop-body-right-a,
.centerTop-body-right-b,
.centerTop-body-right-c {
  opacity: 1;
  font-family: PingFang SC;
  font-size: 0.7292vw;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
}
.centerTop-body-right-a {
  position: absolute;
  bottom: 5.2083vw;
  left: 33.0729vw;
}
.centerTop-body-right-b {
  position: absolute;
  bottom: 3.2292vw;
  left: 33.0729vw;
}
.centerTop-body-right-c {
  position: absolute;
  bottom: 1.25vw;
  left: 33.0729vw;
}
.center-icon {
  width: 28.3333vw;
  height: 15.5729vw;
  position: absolute;
  left: 8.2292vw;
  top: 2.0313vw;
}
.jihuojiantou {
  margin-top: 0.3vw;
  margin-right: 1.0417vw;
  float: left;
  width: 1.7188vw;
  height: 1.5625vw;
}
.jihuojiantouimg {
  width: 1.7188vw;
  height: 1.5625vw;
}
.leftTopIcon{
  width: 1.8115vw;
  height: 1.8115vw;
  margin-right: .6563vw;
}
</style>
<style scoped>
 @import '../../untils/screenTop.css'
</style>